import React from 'react';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { MATCHING_ROUND_COLORS } from './colors';

interface IProps {
  status: string;
}

export const MatchingRoundCircle: React.FC<IProps> = ({status}) => {
  const getIconVariant = (status: string) => (
    {
      bgcolor: MATCHING_ROUND_COLORS[status].bg,
      border: "1px solid " + MATCHING_ROUND_COLORS[status].text,
      width: 24,
      height: 24
    }
  );
  return status ? (<Tooltip title={status}><Avatar sx={getIconVariant(status)} alt={status}> </Avatar></Tooltip>): null;
};